// Cliente HTTP mínimo para el Portal API — mismo origen en producción (servido como estático por
// el propio `portal`, ver docs/adr/001-portal-architecture.md), proxy de Vite en desarrollo (ver
// vite.config.ts). `credentials: "include"` es necesario para que la cookie de sesión
// (httpOnly, SameSite=Strict) viaje en cada request — ver docs/adr/004-authentication.md.

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    credentials: "include",
    headers: body !== undefined ? { "Content-Type": "application/json" } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 204) {
    return undefined as T;
  }

  const contentType = res.headers.get("content-type") ?? "";
  const data: unknown = contentType.includes("application/json") ? await res.json() : undefined;

  if (!res.ok) {
    const errorBody = data as { error?: string; message?: string } | undefined;
    throw new ApiError(res.status, errorBody?.error ?? "UNKNOWN_ERROR", errorBody?.message ?? res.statusText);
  }

  return data as T;
}

export const apiGet = <T>(path: string): Promise<T> => request<T>("GET", path);
export const apiPost = <T>(path: string, body?: unknown): Promise<T> => request<T>("POST", path, body);
export const apiPatch = <T>(path: string, body?: unknown): Promise<T> => request<T>("PATCH", path, body);
